import React from 'react';
import { Helmet } from 'react-helmet-async';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_casaloco-flavors/artifacts/mrxtkbpi_Casa%20Loco%20Logo%20%285%29.png";

const SEO = ({ title, description, path = "/" }) => {
  const siteUrl = "https://casaloco.in";
  const fullUrl = `${siteUrl}${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content="restaurant" />
      <meta property="og:image" content={LOGO_URL} />
      <meta property="og:site_name" content="Casa Loco India" />
      <meta property="og:locale" content="en_IN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={LOGO_URL} />
    </Helmet>
  );
};

export default SEO;